@if (bestandsmallar) {
  <rask-simple-selector
    #mallSelector
    [viewFormatter]="viewFormatterMallar"
    [disabled]="kontraktReadonly"
    class="w-100"
    bindLabel="text"
    (change)="mallSelected($event)"
    label="Välj beståndsmall"
    intent="delete"
    (itemIconClick)="tryDeleteMall($event)"
    [values]="bestandsmallar">
  </rask-simple-selector>
}

<div class="d-flex mx-0 mt-1 position-relative">
  <rask-action-button
    icon="fas fa-solid fa-floppy-disk"
    color="primary"
    aid="buttonsparasnabbkalkylmall"
    (click)="openSavepopup()"
    [showChevron]="false"
    [disabled]="kontraktReadonly">
    Spara mall
  </rask-action-button>

  @if (showPanel) {
    <div #saveMallPanel class="save-mall-panel">
      <rask-input label="Mallnamn" [(ngModel)]="mallNamn" [disabled]="kontraktReadonly"></rask-input>
      <rask-button [disabled]="!canSave() || kontraktReadonly" color="primary" (click)="trySaveMall($event)">Spara</rask-button>
    </div>
  }
</div>
